export default class Pessoal {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.tipo = 0;
        this.tipoStr = '';
        this.cpfCnpj = '';
        this.identidadeInscricaoEstadual = '';
        this.cep = '';
        this.logradouro = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.bairro = '';
        this.pais = '';
        this.telefone = '';
        this.celular = '';
        this.email = '';
        this.dataNascimentoFundacao = '';

        this.tipoRegime = 0;
        this.tipoRegimeStr = '';
        this.cargo = '';
        this.observacao = '';
        this.dataAdesao = null;
        this.dataSaida = null;
        this.pis = '';
        this.inss = '';
        this.nomeBanco = '';
        this.agencia = '';
        this.contaCorrente = '';
        this.etnia = 0;
        this.etniaStr = '';
        this.sexo = '';
        this.sexoStr = '';
        this.escolaridade = 0;
        this.escolaridadeStr = '';
        this.campo01 = '';
        this.campo02 = '';
        this.campo03 = '';

        this.ativo = true;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.tipo = model.tipo;
        this.tipoStr = model.tipoStr;
        this.cpfCnpj = model.cpfCnpj;
        this.identidadeInscricaoEstadual = model.identidadeInscricaoEstadual;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.bairro = model.bairro;
        this.pais = model.pais;
        this.telefone = model.telefone;
        this.celular = model.celular;
        this.email = model.email;

        this.dataAdesao = model.dataAdesao == null ? null : new Date(model.dataAdesao).yyyymmdd();
        this.dataNascimentoFundacao = model.dataNascimentoFundacao == '' ? new Date() : new Date(model.dataNascimentoFundacao).yyyymmdd();
        this.dataSaida = model.dataSaida == null ? null : new Date(model.dataSaida).yyyymmdd();

        this.tipoRegime = model.tipoRegime;
        this.tipoRegimeStr = model.tipoRegimeStr;
        this.cargo = model.cargo;
        this.observacao = model.observacao;
        this.pis = model.pis;
        this.inss = model.inss;
        this.nomeBanco = model.nomeBanco;
        this.agencia = model.agencia;
        this.contaCorrente = model.contaCorrente;
        this.etnia = model.etnia;
        this.etniaStr = model.etniaStr;
        this.sexo = model.sexo;
        this.sexoStr = model.sexoStr;
        this.escolaridade = model.escolaridade;
        this.escolaridadeStr = model.escolaridadeStr;
        this.campo01 = model.campo01;
        this.campo02 = model.campo02;
        this.campo03 = model.campo03;

        this.ativo = model.dataSaida ? false : true;
    }
}